// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonMenuCapabilities_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10V8L0 8V10L8 10ZM11.5015 8H11.4985C11.3359 8.00049 11.1734 8.08292 11.0792 8.2473L7.06856 15.2415C6.87632 15.5767 7.11114 16 7.48937 16H15.5106C15.8889 16 16.1237 15.5767 15.9314 15.2415L11.9208 8.2473C11.8265 8.08292 11.6641 8.00049 11.5015 8ZM11.5 11.534L10.0859 14H12.9141L11.5 11.534ZM12 6V4L0 4V6L12 6ZM12 2V0H0V2L12 2Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonMenuCapabilities is a generated icon component.
 */
let IconCommonMenuCapabilities = IconCommonMenuCapabilities_1 = class IconCommonMenuCapabilities extends IconBaseElement {
    render() {
        return html `${IconCommonMenuCapabilities_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonMenuCapabilities.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonMenuCapabilities = IconCommonMenuCapabilities_1 = __decorate([
    customElement('zui-icon-common-menu-capabilities')
], IconCommonMenuCapabilities);
export { IconCommonMenuCapabilities };
